import { Component, OnInit, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { ActivatedRoute,Router  } from '@angular/router';
import { Location } from '@angular/common';

import { CommonService } from '../service/common.service';

import { User } from '../service/users.model';
import { UsersService } from '../service/users.service';

import { Role } from '../app.constant';

@Component({
    selector: 'signin-app',
      templateUrl: './signin.component.html',
      styleUrls: ['signin.component.css']
    })

export class SigninComponent {

        constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService,
        private usersService: UsersService,
        private location: Location,
    ) { }

    ROLE: any = Role;
    isLoaded : boolean = false;
    authType: string = null;

    signinmodel: any = {};

    title="Sign-in";

    responce:any={};

    signinIn :boolean;
    signinMessageFlg:boolean;
    signinMessage:string;
    selected_kcd: string = null;

    ngOnInit(): void {
        this.commonService.loadingStart();
        var page_url = location.href;
        var match = page_url .includes("wellnessSupportToolsSec");
        // var match = page_url .includes("localhost");
        this.selected_kcd = this.route.snapshot.paramMap.get('kcd');
        if(match){
            this.contractInfo();
        }else{
            this.signinIn = false;
            this.signinMessageFlg=false;
            this.signinMessage="";
            this.isLoaded = true;
            this.commonService.loadingEnd();
        }
    };

    signin(mode:number): void {
        if(mode == 1){
            this.title = "Sign-in now...";
        }
        this.signinIn = true;
        this.signinMessageFlg = false;
        this.signinMessage = "sign in …";
        let param ={
            kid:this.selected_kcd
        };
        this.usersService.signin(this.signinmodel,this.selected_kcd)
        .subscribe((res: Response) => {
            if(res["fuel_status"] == "NG"){
                if (res["fuel_message"] == "Locked"){
                    this.commonService.modalOpens(11010, modalresult => { });
                }else if (res["fuel_message"] == "Expired"){
                    this.commonService.modalOpens(11011, modalresult => {
                        this.router.navigate(["/fpassword"]);
                     });
                }else{
                    this.signinMessageFlg = true;
                    this.signinMessage = "sign in NG. Check your ID and Password";
                }
            }else{
                this.signinMessageFlg = false;
                this.usersService.regUserInfo(res["fuel_results"]);
                this.usersService.isSignin = true;
                //Loading停止
                this.commonService.loadingEnd();
                if (res["fuel_results"]["role_id"]== this.ROLE.ADMIN){
                    this.router.navigate(["/admin"]);
                }else if(res["fuel_results"]["role_id"]== this.ROLE.SYSTEM){
                    this.router.navigate(["/system"]);
                }else if(res["fuel_results"]["role_id"]== this.ROLE.USER){
                    if(res["fuel_results"]["first_logined"]==0 && res["fuel_results"]["password_change_flg"]==1 ){
                        if(mode == 1){
                            this.router.navigate(["/home"]);
                        }else{
                            this.router.navigate(["/fpassword"]);
                        }
                    }else{
                        this.router.navigate(["/home"]);
                    }
                }else{
                    this.router.navigate(["/signin"]);
                }
            }
          },error => {
            this.commonService.modalOpens(error,modalresult=>{});
          });
    }
    signout():void{
        this.usersService.signout()
        .subscribe();
    }
    contractInfo(): void{
        this.usersService.getContractInfo(this.selected_kcd)
        .subscribe((res: Response) => {
            if(res["fuel_status"] == "NG"){
                // 処理なし
            }else{
                //管理者だったらadmin　一般だったらhomeへ遷移
                this.signinmodel.username = res["fuel_results"]["account"];
                this.signinmodel.password = res["fuel_results"]["password"];
                this.authType = res["fuel_results"]["auth_type"];
                if(this.authType == 'Shibboleth'){
                    this.signin(1);
                }else{
                    // this.signinIn = false;
                    // this.signinMessageFlg=false;
                    // this.signinMessage="";
                    // this.isLoaded = true;
                    // this.commonService.loadingEnd();
                    location.href = 'https://abr-net.com/wellnessSupportTools/';
                }
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
  /**
   * 親コンポーネントに対してイベントを発火するためのプロパティ
   *
   * @memberof CompChildComponent
   */
  @Output() event = new EventEmitter<String>();

  ssoPageKwansei():void{
    location.replace("https://abr-net.com/wellnessSupportToolsSec/");
  }

}



// WEBPACK FOOTER //
// ./src/app/c9901-signin/signin.component.ts